"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var globalNavDefaults = {
  borderBottom: {
    width: '1px',
    style: 'solid',
    color: 'greymid'
  },
  globalNavWrapBg: 'white',
  primaryLinksColor: 'black',
  secondaryLinksColor: 'white',
  secondaryNavCtaVariant: 'secondary',
  isLargeNavBreak: 'xlarge',
  isLargeSliderBreak: 'medium',
  megaSliderColor: 'white',
  megaSliderHeaderBg: 'black',
  megaSliderHeaderBorder: '0',
  megaSliderHeaderBorderColor: 'transparent',
  megaSliderMainBg: 'primary',
  borderBurgerWrap: {
    width: '1px',
    style: 'solid',
    color: 'greymid'
  },
  burgerColor: 'black',
  burgerColorHover: 'secondary',
  megaBurgerActiveColor: 'white',
  megaBurgerActiveColorHover: 'white',
  burgerLabelTransform: 'uppercase',
  burgerLabelSizeDesktop: '2.7rem',
  burgerLabelSizeMobile: '2.1rem',
  sliderFooterLinkColor: 'white',
  sliderActionFontSizeMobile: '1.8rem',
  sliderActionFontSizeDesktop: '2.8rem',
  sliderActionVariant: 'primary',
  sliderActionInverted: false,
  actionsWrapBorder: '1px solid #D2D2D2',
  // this is a fix for IE11 because the fonts are not loaded properly
  burgerLabelMarginTopIE: '0',
  buttonTextMarginIE: null,
  // Primary Menu styling
  primaryMenuSliderColor: 'primary',
  primaryMenuSliderMainBg: 'secondary',
  primaryMenusliderHeaderBg: 'secondary',
  primaryMenuSliderHeaderBorder: '1px solid',
  primaryMenuSliderHeaderBorderColor: 'greymid',
  primaryMenuBurgerActiveColor: 'primary',
  primaryMenuBurgerActiveColorHover: 'primary',
  primaryMenuAccountNavBorder: '1px solid rgba(220, 220, 222, .8)',
  primaryMenuLinkFontSize: '2.1rem',
  primaryMenuLinkLineHeight: '2.5rem',
  // UtilityNav
  utilityNavBg: '#D8D8D8',
  // SliderNavItem
  navItemExpandedBgHeader: 'primary',
  navItemIconColorHeader: 'white',
  navItemTextColorHeaderExpandedMobile: 'white',
  navItemTextColorHeaderMobile: 'white',
  subNavItemSoloColor: 'primary',
  subNavItemSoloColorHover: 'primary',
  subNavItemSoloColorMega: 'white',
  subNavItemSoloColorMegaHover: 'white',
  navItemHeaderFontSize: 'initial',
  navItemTextTransform: 'uppercase',
  navItemTextColorHeaderDesktop: 'white',
  primaryNavItemTextColor: 'primary',
  navItemDescriptionOpacity: '.6',
  subNavItemColorHeaderExpanded: 'white',
  subNavItemColorHeader: 'white',
  subNavItemColorHoverHeader: 'white',
  subNavItemContainerHomeBorder: '2px solid rgba(38,38,38, .4)',
  subNavItemTextHomeBorder: '1px solid',
  subNavItemTextHomeBorderColor: 'primary',
  subNavItemTextHomeExpandedBorderColor: 'white',
  primarySubNavItemContainerHomeBorder: '2px solid rgba(101,103,112, .23)',
  primarySubNavItemTextHomeBorderColor: '2px solid rgba(101,103,112, .23)',
  mainNavLinkH4Color: 'greydark'
};
var globalNav = {
  horizon: _objectSpread({}, globalNavDefaults),
  cannesLions: _objectSpread({}, globalNavDefaults),
  lionsLive: _objectSpread({}, globalNavDefaults),
  money2020: _objectSpread(_objectSpread({}, globalNavDefaults), {}, {
    navItemTextColorHeaderDesktop: 'greydark',
    subNavItemTextHomeExpandedBorderColor: 'greydark'
  }),
  ascential: _objectSpread({}, globalNavDefaults),
  dcl: _objectSpread(_objectSpread({}, globalNavDefaults), {}, {
    sliderMainBg: 'accent3'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, globalNavDefaults), {}, {
    megaSliderHeaderBg: 'primary',
    megaSliderHeaderBorder: '1px solid',
    megaSliderHeaderBorderColor: 'rgba(255, 255, 255, .6)',
    globalNavWrapBg: 'secondary',
    burgerColor: 'primary',
    burgerColorHover: 'primary',
    sliderActionVariant: 'secondary',
    sliderActionInverted: true,
    actionsWrapBorder: '1px solid rgba(255, 255, 255, .5)',
    burgerLabelMarginTopIE: '12px',
    buttonTextMarginIE: '14px',
    // SliderNavItem
    navItemHeaderFontSize: '2.7rem',
    navItemDescriptionOpacity: '1',
    subNavItemColorHeader: 'primary',
    subNavItemContainerHomeBorder: '2px solid rgba(255,255,255, .4)'
  })
};
var _default = globalNav;
exports.default = _default;